import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"download\"><path d=\"M16 26H6v2h20v-2H16zM22.29 16.88L17 22.17V4h-2v18.17l-5.29-5.29-1.42 1.41L16 26l7.71-7.71-1.42-1.41z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/download.svg
// module id = m1pJ
// module chunks = 39 44